import api from '../../../../App/socket';

export const createUserAddress = (country, city, street, zip_code, state, user_id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedCreate',
        options: {
            create: {
                country, city, street, zip_code, state,
            },
            where: {
                _id: user_id,
            },
            fullPath: 'person.addresses',
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_addresses_requests/create_user_addresses_request.js